module.exports = ".sb1 .col-md-4, .sb1 .col-md-2{\r\n   padding: 0px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master-account/sb-account/sb-account.component.css
// module id = ./src/app/master-account/sb-account/sb-account.component.css
// module chunks = main